// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PeriodPreviewResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/period_preview
 *
 * Aggregate calculation preview shaped per-user grouping with totals.
 * Both `users` and `totals` are dynamic-keyed aggregate maps assembled
 * from multiple model joins; treating them as opaque preserves the
 * existing wire shape until the preview pipeline is itself contract-typed.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_PeriodPreviewResponseDados {
users: Record<number | string, unknown>
totals: Record<string, unknown>
}

export type Payroll_PeriodPreviewResponse = ApiResponse<Payroll_PeriodPreviewResponseDados>;

registerResponseContract('Payroll_PeriodPreviewResponse', {
  users:  { type: 'object',  required: true },
  totals: { type: 'object',  required: true },
})
